import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MbscSelectOptions } from '@mobiscroll/angular';
import { MbscSelectOnFilterEvent } from '@mobiscroll/angular/dist/js/core/components/select/select';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotifierService } from 'angular-notifier';
import { DirtyTrackingService } from 'src/app/core/dirty-tracking/dirty-tracking.service';
import { ListFilter } from 'src/app/core/list-filter.model';
import { PDxListItem } from 'src/app/core/PDxListItem.model';
import { ajaxCall, DataTablesResponse } from 'src/app/core/services/ajax-call.service';
import { ConfirmService } from 'src/app/core/services/confirm.service';
import { UserAssignmentSummary } from '../models/user-assignment-summary.model';
import { UserDetail } from '../models/user-detail.model';
import { ViewUserAssignmentComponent } from '../view-user-assignment/view-user-assignment.component';

@Component({
  selector: 'app-view-user-assignment-list',
  templateUrl: './view-user-assignment-list.component.html',
  styles: [
  ]
})
export class ViewUserAssignmentListComponent implements OnInit {
  @Input() userId: string;

  showList: boolean = false;
  accounts: PDxListItem<string>[] = [];
  filterCount: number = 0;
  selectOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    onFilter: (ev: MbscSelectOnFilterEvent) => {
      var fCt = ++this.filterCount;
      this.accounts = [];
      if (ev.filterText) {
        this.ajax.MakeCall<PDxListItem<string>[]>('/Entity/DropDownList', { accountId: null, query: ev.filterText }, false).then((data) => {
          if (fCt == this.filterCount) {
            this.accounts = data;
            if (this.accounts.filter((x) => x.value == this.filter.accountId).length == 0) {
              this.filter.accountId = null;
            }
          }
        }, () => { });
      } else {
        if (this.accounts.filter((x) => x.value == this.filter.accountId).length == 0) {
          this.filter.accountId = null;
        }
      }
      return false;
    },
    onChange: (event, inst) => {
      this.hideTheList();
    },
    buttons: [{
      text: 'clear', handler: (event) => {
        this.filter.accountId = null;
        this.hideTheList();
      }
    }]
  };
  filter: UserAssignmentListFilter;
  results: DataTablesResponse<UserAssignmentSummary>;
  user: UserDetail;
  userPermissionList: PDxListItem<boolean>[] = [
    { value: null, text: 'Any' },
    { value: true, text: 'Whitelisted Only' },
    { value: false, text: 'Blacklisted Only' },
  ];

  constructor(private ajax: ajaxCall,
    private modal: NgbActiveModal,
    private modalService: NgbModal,
    private router: Router,
    private notifier: NotifierService,
    private dirtyService: DirtyTrackingService,
    private confirm: ConfirmService) { }

  ngOnInit(): void {
    this.accounts = [];
    this.resetFilters();

    this.ajax.MakeCall<UserDetail>('/User/Detail', { userId: this.userId }).then(results => {
      this.user = results;
      this.showTheList();
    }, () => { console.log('error'); });
  }

  resetFilters(): void {
    this.filter = new UserAssignmentListFilter(10, 'Entity', 'asc');
    this.filter.userId = this.userId;
    this.filter.userPermission = this.userPermissionList[0];
    this.hideTheList();
  }

  dismiss(): void {
    this.modal.dismiss();
  }

  showTheList(): void {
    if (!this.showList) {
      this.loadList(true);
    }
  }

  hideTheList(): void {
    this.showList = false;
  }

  loadList = (reset: boolean = false) => {
    if (reset) {
      this.filter.page = 1;
    }
    this.ajax.MakeCall<DataTablesResponse<UserAssignmentSummary>>('/User/FullAssignmentList', this.filter).then(results => {
      this.results = results;
      this.showList = true;
    }, () => { console.log('error'); });
  }

  selectUserPermission(x: PDxListItem<boolean>): void {
    this.filter.userPermission = x;
    this.hideTheList();
  }

  viewAssignment(entityId: string): void {
    const modal = this.modalService.open(ViewUserAssignmentComponent, { size: 'lg', beforeDismiss: () => { return this.dirtyService.isClean(); } });
    modal.componentInstance.user = this.user;
    modal.componentInstance.parentId = entityId;
    modal.result.then(() => { this.loadList(); }, () => { });
  }

  blacklistEntity(entityId: string): void {
    this.confirm.confirm('Blacklist Entity?', 'Are you sure that you want to remove all permissions from this entity and all of its children?').then(() => {
      this.ajax.MakeCall('/User/Blacklist', { userId: this.user.userId, entityId: entityId }).then(() => {
        this.loadList();
      }, () => { });
    }, () => { });
  }

  resetPermissions(entityId: string): void {
    this.confirm.confirm('Reset Entity to Inherit?', 'Are you sure that you want to reset this user\'s access to this entity and all of its children based on its parent?').then(() => {
      this.ajax.MakeCall('/User/ResetPermissions', { userId: this.user.userId, entityId: entityId }).then(() => {
        this.loadList();
      }, () => { });
    }, () => { });
  }

  manageEntity(entityId: string): void {
    this.router.navigate(['/manage/entity-mgmt', entityId, 'profile']);
    this.dismiss();
  }
}

class UserAssignmentListFilter extends ListFilter {
  userId: string;
  accountId?: string;
  userPermission: PDxListItem<boolean>;
}